import React from 'react';
import { Box, Grid } from '@mui/material';
import { reusableStyles, tabletBreakpoint } from 'core/layouts/ui-blocks/ReusableStyles';
import { oneTimePurchaseComponentStyles } from 'platform/web/one-time-purchase-component/OneTimePurchaseComponentStyles';
import OneTimePaymentPlans from 'core/layouts/components/one-time-payment-plans/OneTimePaymentPlans';
import BaseTypography from 'core/components/typography/BaseTypography';

function OneTimePurchaseComponent({ posthogEvent, amplitudeEvent }) {
	return (
		<Box
			id="buy-credits-page-data"
			sx={[reusableStyles.flexCol, { width: '100%', marginTop: '16px' }]}
		>
			<Grid container spacing={3}>
				<Grid item sm={12}>
					<Grid item sx={{ marginTop: { xs: '16px', [tabletBreakpoint]: '32px' } }}>
						<Box sx={[oneTimePurchaseComponentStyles.creditsSection, { width: '100%' }]}>
							<OneTimePaymentPlans posthogEvent={posthogEvent} amplitudeEvent={amplitudeEvent} />
						</Box>
					</Grid>
				</Grid>
			</Grid>
			<BaseTypography
				id="credit-value-title"
				variant="b1_regular"
				sx={oneTimePurchaseComponentStyles.creditValueTitle}
			>
				1 credit = 1 image generation
			</BaseTypography>
		</Box>
	);
}

export default OneTimePurchaseComponent;
